import Vue from "vue";
import { mapGetters } from "vuex";
import { ResourceLibrarySideMenu } from "@/components/SubMenus";
import { LoadingSpinner } from "@/components";
import { ListLayout } from "@/components/layouts";
import { paginationMixin } from "@/components/mixins";
import { ErrorLogService } from "@/services/ErrorLogService";
import { ResourceLibraryService } from "@/services/ResourceLibraryService";
import { stringHelper } from "@/components/mixins/stringHelper";
import { MediaService } from "@/services/";
import { controlsHelper } from "@/components/mixins/commonControlsHelper"


export default Vue.extend({
  name: "ResourceLibrary",
  components: {
    ResourceLibrarySideMenu,
    LoadingSpinner,
    ListLayout
  },
  mixins: [paginationMixin, stringHelper, controlsHelper],
  props: {
    resourceLabelId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    searchInput: '',
    searchText: '',
    resourceLibraryLoading: true,
    searchResults: [],
    allResults: [], // Store all results for filtering
    uniqueMediaLabels: [],
    selectedLabels: [],
  }),
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "activeAccountId",
      "McfCostCenterId",
      "audienceIds"
    ]),
  },
  created() {
    this.loadResourceLibrary();
  },
  methods: {
    getUniqueMediaLabels() {
      // Use allResults to get all possible labels
      const labels = this.allResults
        .flatMap((item: any) => Array.isArray(item.MediaLabel) ? item.MediaLabel : [])
        .filter((label: string | undefined) => !!label);
      this.uniqueMediaLabels = Array.from(new Set(labels));
    },
    selectLabel(label: string) {
      if (this.selectedLabels.includes(label)) {
        this.selectedLabels = this.selectedLabels.filter(l => l !== label);
      } else {
        this.selectedLabels = [...this.selectedLabels, label];
      }
      this.filterResultsByLabels();
    },

    filterResultsByLabels() {
      if (this.selectedLabels.length === 0) {
        this.searchResults = this.allResults;
      } else {
        this.searchResults = this.allResults.filter((item: any) =>
          Array.isArray(item.MediaLabel) &&
          item.MediaLabel.some((label: string) => this.selectedLabels.includes(label))
        );
      }
    },

    downloadLink(fileId) {
      return MediaService.getMediaUrl(fileId);
    },

    onSearch() {
      this.loadResourceLibrary(this.searchInput);
    },
    loadResourceLibrary: function (searchTerm = "") {
      this.resourceLibraryLoading = true
      var params = {
        CostCenterId: this.McfCostCenterId,
        AccountId: this.activeAccountId,
        UserId: this.user?.UserId,
        UserAudiences: this.audienceIds,
        SearchTerm: searchTerm
      }

      return ResourceLibraryService.DocumentSearch(params)
        .then(results => {
          this.allResults = results;
          this.searchResults = results;
          this.filterResultsByLabels();
          this.getUniqueMediaLabels();
          this.searchText = searchTerm;
          return results;
        })
        .catch(err => {
          ErrorLogService.LogException(err);
          return [];
        })
        .finally(() => {
          this.resourceLibraryLoading = false
        })
    },
  }
});